import * as d3 from 'd3'
export default {

  methods: {

    draw_legends() {

      if(this.legends.visible != 'Y') return

      let item = this.canvasForm
      .append('g')
      .attr('id', `LEGEND_GROUP`)
      .attr('transform', `translate(${this.chart.x}, ${this.legends.y})`)

      let x_ = 0
      this.chart.columns.filter(f=> f.type != this.legends.exclude).forEach((d,i)=> {
       
        if(d.type == 'LINE') {
          item
          .append('line')
          .attr('x1', x_).attr('x2', x_ + 10)
          .attr('y1', 0).attr('y2', 0)
          .attr('stroke', d.color).attr('stroke-width', 1).style('stroke-dasharray', (d.ltype, d.ltype))
        }

        if(d.type == 'BAR') {
          item
          .append('rect')
          .attr('x', x_+3).attr('y', -4)
          .attr('width', 7).attr('height', 7).attr('fill', d.color).attr('opacity', d.opacity)
        }

        item
        .append('text')
        .attr('id', `LEGEND_${i}`)
        .attr('transform', `translate(${x_ + 15}, 3)`)
        .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
        .text(d.name)

        x_ = x_ + this.getNode(`#LEGEND_${i}`, 'width') + 25
      })
    },



    draw_Summary(_data, st, sn) {
      
      let sum = this.summary

      let lastMonth = _data.find(f=> f.CDATE == this.timeline.cutoff)
      if(!lastMonth) return

      let x = lastMonth.mx + 5
      let y = this.primary.axis(lastMonth[st.code])+5

      this.canvasSummary = this.svg
      .append('g')
      .attr('id', `LAST_SUMMARY`)
      .attr('transform', `translate(${this.chart.x}, ${this.chart.y})`)

      let summary = this.canvasSummary
      .append('g')
      .attr('transform', `translate(${x}, ${y-5})`)
      
      
      let size = sum.box.sizes
      summary
      .append('path')
      .attr('d', this.gmx_TooltipPath('right', size[0], size[1], size[2], size[3]))
      .attr('fill', sum.box.fill).attr('fill-opacity', sum.box.opacity)
      .attr('stroke', sum.box.stroke).attr('stroke-width', .5)

      let contents = summary
      .append('g')
      .attr('transform', `translate(${sum.content.x}, ${sum.content.y - (size[1]/2)})`)

      
      let y_ = 0
      sum.cols.forEach(column=> {

        column.forEach((col,c)=> {
          if(col.name) {
            contents
            .append('text')
            .attr('x', sum.content.sx[c]).attr('y', y_)
            .attr('font-size', col.tSize ? col.tSize : sum.content.tSize)
            .attr('fill', col.tColor ? col.tColor : sum.content.tColor)
            .text(col.name)
          }

          if(col.code) {
            contents
            .append('text')
            .attr('x', sum.content.sx[c]).attr('y', y_)
            .attr('font-size', col.tSize ? col.tSize : sum.content.tSize)
            .attr('fill', ()=> {
              let color =  sum.content.tColor
              if(col.tColor) color = col.tColor
              if(col.type == 'delta') color = this.gmx_deltaValue(lastMonth[col.code])
              return color
           })
            .text(lastMonth[col.code]+'%')
          }
        })

        y_ += sum.content.lineheight
      })

      
    },

  }
}